(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/controllers/maltipset-controller.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/controllers/maltipset-controller.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.maltipset.controllers.MaltipsetController = Marionette.MnObject.extend({
    initialize: function() {
      this.initializeModels();
      this.contextMenu = new svs.maltipset.objects.ContextMenuHandler();
    },
    initializeModels: function() {
      this.app = this.options;

      svs.maltipset.collections.draws = new svs.maltipset.collections.Draws();

      if (svs.maltipset.collections.draws.length > 0) {
        svs.maltipset.models.storageCoupon = new svs.maltipset.models.StorageCoupon({
          cancelCloseTime: svs.maltipset.collections.draws
            .first()
            .get('cancelCloseTime')
        });
        svs.maltipset.collections.coupons = new svs.maltipset.collections.Coupons();
      }
    },
    initContextMenu: function(options) {
      this.contextMenu.initContextMenu(options);
    },
    showSystemspel: function() {
      this.contextMenu.contextMenuData.showSystemspel();
    },
    convertSystem: function(toSystem) {
      this.contextMenu.contextMenuData.convertSystem(toSystem);
    },
    showXperten: function() {
      this.contextMenu.contextMenuData.showXperten();
    },
    betslipListeners: function() {
      var self = this;
      this.triggerScroll = function() {
        $('.js-swiper-container')
          .has('#coupon')
          .trigger('scroll');
        setTimeout(function() {
          svs.maltipset.views.betslip.setWidth();
        }, 300);
      };
      this.triggerScroll = this.triggerScroll.bind(this);

      this.runBetslip = _.debounce(function() {
        svs.maltipset.views.betslip.initRelativeBetslip();
        svs.maltipset.views.betslip.betslipStickyBehaviour();
        self.triggerScroll();
      }, 500);

      $(window).on('resize', this.runBetslip);
    },
    showBetslip: function(coupon) {
      var self = this;
      var betslipController = new svs.maltipset.controllers.Betslip({
        coupon: coupon,
        controller: this
      });
      this.betslip = new svs.app.betslipv2.Betslip(betslipController);
      svs.maltipset.views.betslip = this.betslip;

      if (svs.core.detect.formfactor.mobile()) {
        this.app.skeleton.getRegion('betslip').show(this.betslip);
      } else {
        svs.maltipset.views.coupon.getRegion('betslip').show(this.betslip);
      }
      this.betslip
        .getRegion('betslipFooter')
        .show(new svs.maltipset.views.BetslipFooter({ model: coupon }));
      this.betslip.getRegion('betslipPayOptions').show(new svs.maltipset.views.BetslipPayOptions({
        coupon: coupon,
        betslip: this.betslip
      }));
      this.betslip
        .getRegion('betslipPay')
        .show(new svs.maltipset.views.BetslipPaymentFooter({ model: coupon }));

      this.betslip.initRelativeBetslip();
      setTimeout(function() {
        self.betslip.betslipStickyBehaviour();
      }, 1000);
      this.betslipListeners();

      betslipController.toggleFooter();
    },
    hideBetslip: function() {
      if (this.betslip) {
        this.betslip.collapseBetslip();
      }
    }
  });
})(Backbone, _, svs);


 })(window);